export default {
  dark: 'Întunecat',
  light: 'Deschis',
};
